<div [ngClass]="['logo', theme]"><img class="logo-img" [src]="logoPath()" type="primary" /></div>
